import { interpolateTemplate } from '../../../lib/helpers';

interface URLGeneratorConfig {
  routeTemplate: string;
  baseUrl?: string;
  editorKey?: string;
}

export class URLGenerator {
  private readonly config: URLGeneratorConfig;

  constructor(config: URLGeneratorConfig) {
    this.config = config;
  }

  getURL(object: Record<string, any>, draft: boolean): URL {
    let base = this.config.baseUrl ?? '';
    while (base.endsWith('/')) base = base.slice(0, -1);
    const url = new URL(`${base}/api/flotiq/draft`);

    url.searchParams.set('key', this.config.editorKey ?? '');

    const path = interpolateTemplate(this.config.routeTemplate, object);

    url.searchParams.set('draft', draft.toString());
    url.searchParams.set('redirect', `/${path.replace(/^\//, '')}`);

    return url;
  }
}
